<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div>
  <h2>Outputs</h2>
  @for (output of outputs; track output) {
    <div>
      <cas-module-output
        [moduleName]="moduleName"
        [output]="output"
      ></cas-module-output>
    </div>
  }
</div>
